export const sv = {
  // Certificate Headers
  congrats_message: "Din wifi-installation är klar och certifierad av RouteThis!",
  installation_details: "Detaljer om installationen",
  wireless_speed_test: "Trådlöst snabbhetstest",
  wireless_performance: "Wireless Performance",
  photos: "Foton",
  signal_maps: "Signalkartor",

  // Certificate Room Names
  singular_room: "Rum",
  room_type_bathroom: "Badrum",
  room_type_bedroom: "Sovrum",
  room_type_dining_room: "Matsal",
  room_type_entry_or_hall: "Entré/hall",
  room_type_garage: "Garage",
  room_type_kitchen: "Kök",
  room_type_living_room: "Vardagsrum",
  room_type_office: "Kontor",
  room_type_other: "Övrigt",

  // Pod Name
  pod_1: "Nätkapsel",
  pod_2: "Åtkomstpunkt",
  pod_3: "Nätnods",
  pod_4: "Nätpucks",
  pod_5: "Beacon",
  pod_6: "Nätkapsel",
  pods_1: "Nätkapslar",
  pods_2: "Åtkomstpunkter",
  pods_3: "Nätnoder",
  pods_4: "Nätpuckar",
  pods_5: "Beacons",
  pods_6: "Nätkapslar",

  // Router Name
  router_1: "Routern",
  router_2: "Modemet",
  router_3: "Gateway",
  router_4: "Hubb",
  router_5: "Routern",

  // Level Name
  level_1: "Våning",
  level_2: "Våning",
  levels_1: "Våningar",
  levels_2: "Våningar",

  // Certificate Pod Info
  recommended: "Rekommenderad",
  installed: "Installerad",
  total: "Totalt",

  // Certificate Signal Table
  front_building: "Framsidan av byggnaden",
  speed: "Snabbhet",
  video: "Video",
  rssi: "RSSI",
  rssi_description: "dBm",
  link: "Länk",
  frequency_short: "Frekvens",
  frequency_description: "MHz",
  channel_short: "Kan.",

  // Certificate Legend
  legend: "Teckenförklaring",
  measured_speed: "Uppmätt hastighet",
  measured_speed_description: "Mbps",

  // Certificate Speedtest Result
  speedtest_passed: "Snabbheten är vad man kan vänta sig på de flesta mobila enheter. Alla trådlösa enheter har inte möjlighet att nå maxhastigheten. Se tester för olika rum nedan.",
  speedtest_failed: "Testat på telefon eller surfplatta. Alla trådlösa enheter har inte möjlighet att nå maxhastigheten. Se tester för olika rum nedan.",
}